module.exports = __webpack_public_path__ + "baeb7158283c548b99d20850a7b76fc7.jpg";